import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Message } from "element-ui";

export async function GetLoyaltyItems({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/loyalty/item", option);
    commit("LOYALTY_ITEM_SUCCESS", _response);
  } catch (error) {
    commit("LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function CreateLoyaltyItem({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("CREATE_LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.post("/v1/loyalty/item", form);
    commit("CREATE_LOYALTY_ITEM_SUCCESS", _response.data);
    Message({
      message: "Create completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("CREATE_LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function GetLoyaltyItem({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("GET_LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.get("/v1/loyalty/item", id);
    commit("GET_LOYALTY_ITEM_SUCCESS", _response);
  } catch (error) {
    commit("GET_LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function UpdateLoyaltyItem({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/loyalty/item/", form);
    commit("EDIT_LOYALTY_ITEM_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
    router.go(-1);
  } catch (error) {
    commit("EDIT_LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function UpdateStatusLoyaltyItem({ commit }, form) {
  try {
    ApiService.init("heroku");
    commit("EDIT_LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.put("/v1/admin/" + form.id, form);
    commit("EDIT_LOYALTY_ITEM_SUCCESS", _response);
    Message({
      message: "Update completed",
      type: "success"
    });
  } catch (error) {
    commit("EDIT_LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function DeleteLoyaltyItem({ commit }, id) {
  try {
    ApiService.init("heroku");
    commit("DELETE_LOYALTY_ITEM_REQUEST");
    ApiService.setHeader();
    await ApiService.delete("/v1/loyalty/item/" + id);
    commit("DELETE_LOYALTY_ITEM_SUCCESS", id);
    Message({
      message: "Delete completed",
      type: "success"
    });
  } catch (error) {
    commit("DELETE_LOYALTY_ITEM_ERROR", { result: error.message });
  }
}

export async function GetLoyaltyItemCategory({ commit }, option) {
  try {
    ApiService.init("heroku");
    commit("LOYALTY_ITEM_CATEGORY_REQUEST");
    ApiService.setHeader();
    const _response = await ApiService.query("/v1/loyalty/item/category", option);
    commit("LOYALTY_ITEM_CATEGORY_SUCCESS", _response);
  } catch (error) {
    commit("LOYALTY_ITEM_CATEGORY_ERROR", { result: error.message });
  }
}